export const ADD_LIST = "ADD_LIST";
export const REMOVE_LIST = "REMOVE_LIST";
export const RANK_LIST = "RANK_LIST";

export const ADD_SHOW_LIST = "ADD_SHOW_LIST";
export const REMOVE_SHOW_LIST = "REMOVE_SHOW_LIST";

export const ADD_SHOW = "ADD_SHOW";
export const REMOVE_SHOW = "REMOVE_SHOW";

export const ADD_USER = "ADD_USER";
